<template>
  <DashboardLayout>

    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <p class="mb-0 main-identifier fw-semibold">User Functions</p>
      <span class="material-symbols-outlined">arrow_right</span>
      <p class="mb-0 sub-identifier">Create User</p>
    </div>

    <div class="d-flex justify-content-center">

      <div class="form-outer">
        <form @submit.prevent="submitForm">
          <div class="crud-form position-relative">

            <!-- <button type="button" class="close-button" @click="handleClose">
                            &times;
                        </button> -->

            <div class="form-inner">
              <div class="form-header d-flex justify-content-between align-items-center">
                <h1 class="mb-0">Create User</h1>
              </div>

              <div class="form-body">
                <div class="row mt-2 mb-3">
                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-2 label-left d-flex justify-content-end align-items-center"><label
                        for="first_name">User Role</label></div>
                    <div class="col-md-10 input-right">
                      <select class="form-select custom-select" v-model="role" @change="onRoleChange" required>
                        <option value="" disabled> - Select Role - </option>
                        <option v-for="r in roles" :key="r.id" :value="r.id">
                          {{ r.description }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group" id="group_select"
                    v-if="showGroupSelect">
                    <div class="col-md-2 label-left d-flex justify-content-end align-items-center"><label
                        for="first_name">Group</label></div>
                    <div class="col-md-10 input-right">
                      <select class="form-select custom-select" v-model="group" required>
                        <option value="" disabled> - Select Group - </option>
                        <option v-for="g in groups" :key="g.id" :value="g.id">
                          {{ g.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-2 label-left d-flex justify-content-end align-items-center"><label
                        for="first_name">First Name</label></div>
                    <div class="col-md-10 input-right"><input type="text" class="form-control" v-model="first_name"
                        id="first_name" required></div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-2 label-left d-flex justify-content-end align-items-center"><label
                        for="last_name">Last Name</label></div>
                    <div class="col-md-10 input-right"><input type="text" class="form-control" v-model="last_name"
                        id="last_name" required></div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-2 label-left d-flex justify-content-end align-items-center"><label
                        for="email">Email</label></div>
                    <div class="col-md-10 input-right"><input type="email" class="form-control" v-model="email"
                        id="email" required></div>
                  </div>

                </div>

                <div class="d-flex justify-content-center">
                  <button class="submit-btn" type="submit" :disabled="isLoading">
                    <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {{ isLoading ? 'Submitting...' : 'Submit' }}
                  </button>
                </div>
              </div>
            </div>

          </div>
        </form>
      </div>
    </div>

  </DashboardLayout>
</template>

<!-- <script setup>
import { defineOptions } from 'vue'
import DashboardLayout from '../layout/DashboardLayout.vue'

defineOptions({
  name: 'CreateUserPage',
})
</script> -->

<script setup>
import { ref, onMounted, computed } from 'vue'
import axios from 'axios'
import Cookies from 'js-cookie';
import DashboardLayout from '../layout/DashboardLayout.vue'
import Swal from 'sweetalert2';
import { useUserStore } from '@/stores/user'

const userStore = useUserStore()

const roles = ref([])
const groups = ref([])
const role = ref('')
const first_name = ref('')
const last_name = ref('')
const email = ref('')
// const selectedRoleId = ref('')
const group = ref('')

const root_api_url = process.env.VUE_APP_API_ROOT_URL;

const fetchRoles = async () => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/auth/role`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    //roles.value = response.data

    // Only offer roles belonging to the logged-in user's business client, so a
    // Payment admin can't create a Budget user (or vice versa).
    const userBizClientId = userStore.bizClientId

    // Only a free/super-admin user (no named role flag set) may grant the
    // Admin / Super Admin roles - qssu and everyone else must not see them.
    const allRoleFlags = ['qssu', 'dirOfBudget', 'perSec', 'commOfBAndP', 'registryOfficer', 'groupHead', 'groupMember', 'pvInitiator', 'initiator']
    const profileRole = userStore.profile?.role || {}
    const isFreeUser = allRoleFlags.every(flag => !profileRole[flag])

    roles.value = response.data
      .filter(role => role.bizClientId === userBizClientId)
      .filter(role => isFreeUser || !role.roleName?.toLowerCase().includes('admin'))
      .map(role => ({
        id: role.id,
        name: role.roleName,
        description: role.description
      }))

    // console.log(roles.value)
  } catch (error) {
    console.error('Failed to fetch roles:', error)
  }
}

const fetchGroupTypes = async () => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/group-type`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    //roles.value = response.data

    groups.value = response.data.map(group => ({
      id: group.id,
      name: group.name,
      groupHeadId: group.groupHeadId
    }))

    // console.log(groups.value)
  } catch (error) {
    console.error('Failed to fetch roles:', error)
  }
}

const selectedRole = computed(() => roles.value.find(r => r.id === role.value))

const showGroupSelect = computed(() =>
  selectedRole.value && selectedRole.value.description.toLowerCase().includes('group')
)

const onRoleChange = async () => {
  if (showGroupSelect.value) {
    await fetchGroupTypes()
  } else {
    groups.value = []
    group.value = ''
  }
}

onMounted(async () => {
  // bizClientId lives on profile.role, so the role list can't be filtered
  // until the profile has loaded — otherwise the getter returns 0 and every
  // role gets filtered out.
  if (!userStore.profile?.role) {
    try {
      await userStore.fetchProfile()
    } catch {
      // profile fetch failed — fetchRoles below will come back empty
    }
  }

  await fetchRoles()
  document.title = "Create User"
})

const submitForm = async () => {
  const token = Cookies.get('auth_token');
  const userData = {
    firstName: first_name.value,
    lastName: last_name.value,
    email: email.value,
    roleId: role.value,
    groupTypeId: group.value,
  };

  const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

  try {
    await axios.post(`${root_api_url}/auth/register`, userData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });



    Swal.fire({
      html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>User created successfully</p> `,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    });

    role.value = '';
    first_name.value = '';
    last_name.value = '';
    email.value = '';
  } catch (error) {
    if (error.response) {
      Swal.fire({
        html: `${iconHtmlError}
      <h1 style="font-weight:600;">Error</h1>
      <p>${error?.response?.data?.errorMessage || error?.response?.data?.error || 'An error occurred while creating the user.'}</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    } else {
      Swal.fire({
        html: `${iconHtmlError}
       <h1 style="font-weight:600;">Error</h1>
       <p>An error occurred while creating the user.</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    }

  }
};

</script>

<style scoped>
.custom-select option {
  font-size: 18px;
  background-color: #fff;
}
</style>
